import NotFound from "@/Pages/NotFound";
import BaseComponent from "@/components/Empties/BaseComponent";
import SuspenseRouteHandler from "@/components/SuspenseRouteHandler/SuspenseRouteHandler";
import { TRouterSchema } from "@/types/global.types";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { JOURNEY_TABS } from "customer/JOURNEY_TABS";

const journeyRoutes: TRouterSchema[] = [
  {
    path: "",
    element: <BaseComponent />,
  },
  ...JOURNEY_TABS.map((tab): TRouterSchema => {
    const hasSubTabs = tab.subTabs && tab.subTabs.length > 0;
    return {
      path: `${stringUtility.removeSpaceAddChar(tab.name, "-")}${
        hasSubTabs ? "/:subTab" : ""
      }`,
      element: <SuspenseRouteHandler route={tab.name} />,
    };
  }),
  { path: "*", element: <NotFound /> },
];

export default journeyRoutes;
